module.exports = __webpack_public_path__ + "img/magento-support-security.456f4e6d.jpg";